
import {Vue, Component, Emit, Prop} from 'vue-property-decorator';

import {classesApi} from '@/api';
import listRequest from '../../../js/listRequest.js';
import formHelper from '../../../js/classes/classes.helper';
import importStudent from '../../../components/classes-import-student.vue';
import Empty from '@/components/Empty/index.vue';
import New_Class from './new_class.vue';
import Class_Authorize from './class_authorize.vue';
import Course_Card from './course_card.vue';
import Class_Teacher from './class_teacher.vue';

// import fileDownload from 'js-file-download'; //下载excel

@Component({
    components: {
        importStudent,
        Empty,
        New_Class,
        Class_Authorize,
        Course_Card,
        Class_Teacher
    }
})
export default class Classes extends Vue {
    //===================================data区域begin
    query: any = {
        grade: undefined,
        period: '',
        name: '',
        attribute: '',
        sort: '+weight'
    };
    attributeList: any = [
        {label: '行政班', value: 1},
        {label: '兴趣班', value: 2}
    ];
    pageData: any = {
        gradeList: [
            {value: 101, lable: '一年级'},
            {value: 102, lable: '二年级'},
            {value: 103, lable: '三年级'},
            {value: 104, lable: '四年级'},
            {value: 105, lable: '五年级'},
            {value: 106, lable: '六年级'},
            {value: 207, lable: '初一'},
            {value: 208, lable: '初二'},
            {value: 209, lable: '初三'},
            {value: 310, lable: '高一'},
            {value: 311, lable: '高二'},
            {value: 312, lable: '高三'}
        ]
    };
    columns: any = formHelper.classColumns;
    pager: any = {
        default: {
            pagesize: 10,
            pagenum: 1,
            total: 0,
            rows: []
        }
    };
    // 班级loading
    classLoading: boolean = false;
    // 新建/编辑班级模态框显隐
    showNewClass: boolean = false;
    classType: string = 'new';
    classEdit: any = {};

    uploadHeaders: any = {};

    orgName: any = '';

    exportClassId: any = '';
    exportClassName: any = '';

    schoolId: any = '';

    // 顶部切换栏
    isActive: string = 'all';
    // 各学段班级数
    allPhaseCount: number = 0;
    primaryCount: number = 0;
    juniorCount: number = 0;
    seniorCount: number = 0;
    // 新建班级并关联课程
    showClassAuthorize: boolean = false;
    classInfo: any = {
        classId: '',
        className: ''
    };
    // 查看关联课程详情
    courseVisible: boolean = false;
    courseList: any = [];
    // 查看关联教师详情
    visibleTeacher: boolean = false;
    teacherList: any = [];
    // 表格记录 hover 状态
    leftAlignId: any = '';
    columnsTeacher: any = [
        {
            dataIndex: 'className',
            title: '班级名称',
            width: '50%',
            customRender: (value: any, row: any, index: any) => {
                const obj: any = {
                    children: value,
                    attrs: {}
                }; // 筛选出相同 classId 的 rows 数据
                let arr = this.teacherList.filter((res: any) => {
                    return res.classId == row.classId;
                });
                // 不渲染相同 classId 的 row
                if (index == 0 || this.teacherList[index - 1].classId != row.classId) {
                    obj.attrs.rowSpan = arr.length;
                } else {
                    obj.attrs.rowSpan = 0;
                }
                return obj;
            }
        },
        {
            dataIndex: 'teacherName',
            width: '50%',
            title: '关联教师'
        }
    ];
    // 授权课程并关联教师对话框显隐
    visibleTeacher2: boolean = false;
    teacherList2: any = [];
    // 附加课程抽屉数据
    copyCourseVisible: boolean = false;
    //===================================data区域end

    //===================================computed区域begin

    //===================================computed区域end

    //===================================methods区域begin
    // 关联课程后关联教师
    openTeacher(val: any) {
        // console.log(val);
        if (val) {
            this.teacherList2 = val;
            setTimeout(() => {
                this.visibleTeacher2 = true;
            }, 1000);
        }
    }
    // 新增班级
    newClass() {
        // console.log('新增班级');
        this.showNewClass = true;
        this.classType = 'new';
    }
    // 新建班级及关联课程
    showClassAuthorizeFn() {
        let refInfo = this.$refs.newClass as any;
        this.classInfo.classId = refInfo.classInfo.classId;
        this.classInfo.className = refInfo.classInfo.className;
        setTimeout(() => {
            this.showClassAuthorize = true;
        }, 1000);
    }
    // 刷新班级列表
    refreshClassList() {
        this.pager.default.pagenum = 1;
        this.getList();
    }
    // 根据班级名称筛选
    searchClass() {
        this.pager.default.pagenum = 1;
        this.getList();
    }

    // 顶部切换栏
    switchPhase(flag: any) {
        this.pager.default.pagenum = 1;
        this.isActive = flag;
        if (flag == 'all') {
            this.query.period = '';
        } else {
            this.query.period = flag;
        }
        this.getList();
    }

    // 年级选择器
    selectGrade(value: any) {
        this.pager.default.pagenum = 1;
        this.query.grade = value;
        this.getList();
    }
    // 鼠标移入表格某行，行中的字体颜色变化等
    customRowClass() {
        return {
            on: {
                mouseenter: (record: any) => {
                    const row = record.srcElement.children;
                    if (row[6].innerText != '暂无') {
                        row[6].style.color = '#1456ed';
                        row[6].style.cursor = 'pointer';
                    }
                    if (row[7].innerText != '暂无') {
                        row[7].style.color = '#1456ed';
                        row[7].style.cursor = 'pointer';
                    }
                    if (row[8].innerText != '暂无') {
                        row[8].style.color = '#1456ed';
                        row[8].style.cursor = 'pointer';
                    }
                },
                mouseleave: (record: any) => {
                    const row = record.srcElement.children;
                    row[6].style.color = 'rgba(0,0,0,0.9)';
                    row[6].style.cursor = 'auto';
                    row[7].style.color = 'rgba(0,0,0,0.9)';
                    row[7].style.cursor = 'auto';
                    row[8].style.color = 'rgba(0,0,0,0.9)';
                    row[8].style.cursor = 'auto';
                },
                click: (record: any) => {
                    const row = record.srcElement.parentElement.parentElement.parentElement.parentElement.children;
                    if (row[6]) {
                        row[6].style.color = 'rgba(0,0,0,0.9)';
                        row[6].style.cursor = 'auto';
                    }
                    if (row[7]) {
                        row[7].style.color = 'rgba(0,0,0,0.9)';
                        row[7].style.cursor = 'auto';
                    }
                    if (row[8]) {
                        row[8].style.color = 'rgba(0,0,0,0.9)';
                        row[8].style.cursor = 'auto';
                    }
                }
            }
        };
    }
    selectAttribute(value: any) {
        this.pager.default.pagenum = 1;
        this.query.attribute = value;
        this.getList();
    }
    // 切换班级名称排序
    sortClassName(flag: string) {
        this.pager.default.pagenum = 1;
        this.query.sort = flag;
        this.getList();
    }
    // 查看关联课程
    checkCourse(record: any) {
        // console.log(record);
        record.isCopy = false;
        this.courseList = record;
        this.courseVisible = true;
    }
    // 查看附加课程
    checkCopyCourse(record: any) {
        // console.log(record);
        record.isCopy = true;
        this.courseList = record;
        this.copyCourseVisible = true;
    }
    oncourseClose() {
        this.courseVisible = false;
        this.courseList.isCopy = false;
    }
    onCopyCourseClose() {
        this.copyCourseVisible = false;
        this.courseList.isCopy = false;
    }
    // 查看关联教师
    checkTeacher(record: any) {
        // console.log(record);
        for (let i = 0; i < record.teacherList.length; i++) {
            this.teacherList.push({});
            this.teacherList[i].teacherName = record.teacherList[i];
            this.teacherList[i].className = record.name;
        }
        this.visibleTeacher = true;
    }
    onCancel() {
        this.teacherList = [];
        this.visibleTeacher = false;
    }
    // 列表操作项
    handleAuthorize(record: any) {
        // console.log('关联课程', record);
        localStorage.setItem('classInfo', JSON.stringify(record));
        this.$router.push({
            path: '/school/classes/class_authorize',
            query: {
                classId: record._id,
                className: record.name
            }
        });
    }
    handleStudent(record: any) {
        // console.log('查看学生', record);
        localStorage.setItem('classInfo', JSON.stringify(record));
        this.$router.push({
            path: '/school/classes/view_student',
            query: {
                classId: record._id,
                className: record.name
            }
        });
    }
    handleEditClass(record: any) {
        // console.log('编辑班级', record);
        this.classType = 'edit';
        this.classEdit = record;
        this.showNewClass = true;
    }
    handleDeleteClass(record: any) {
        // console.log('删除班级', record);
        let me = this;
        let urlParamObj = {
            id: record._id
        };
        me.$confirm({
            title: '提示',
            content: '删除班级将解除师生与班级的关联，请谨慎操作。',
            centered: true,
            onOk() {
                classesApi.deleteClass({
                    context: me,
                    urlParamObj: urlParamObj,
                    success(data: any) {
                        me.$message.success('操作成功！该班级已删除。');
                        me.getList();
                    },
                    error(error: any, message: string) {
                        me.$message.error('操作失败！该班级有课程正在上课中，暂时无法删除。');
                    }
                });
            },
            onCancel() {}
        });
    }
    // 获取班级列表数据
    getList() {
        let me = this;
        me.classLoading = true;
        let urlQueryParmas = {
            schoolId: me.schoolId,
            name: me.query.name,
            grade: me.query.grade,
            attribute: me.query.attribute,
            period: me.query.period,
            sort: me.query.sort
        };
        classesApi.getClassList({
            context: me,
            pager: me.pager.default,
            urlQueryParmas: urlQueryParmas,
            afterRender(data: any) {
                // console.log(data);
                me.classLoading = false;
            }
        });
    }

    paginationChange(page: number, pageSize: number) {
        this.pager.default.pagenum = page;
        this.getList();
    }

    onShowSizeChange(current: any, pageSize: any) {
        this.pager.default.pagesize = pageSize;
        this.getList();
    }
    //导出班级学生名单
    exportClassStudent() {
        if (this.exportClassId == '') {
            this.$message.warning('请选择要导出的文件');
        } else if (this.exportClassId.length == 1) {
            let url = '/api/v1/user/export/class/student' + '?classId=' + this.exportClassId;
            fetch(url, {
                method: 'GET',
                headers: new Headers({
                    Authorization: this.uploadHeaders['Authorization']
                })
            })
                .then(res => res.blob())
                .then(data => {
                    const blobUrl = window.URL.createObjectURL(data);
                    const a = document.createElement('a');
                    a.download = this.orgName + this.exportClassName[0].name + '学生信息' + '.xlsx';
                    a.href = blobUrl;
                    a.click();
                });
        } else if (this.exportClassId.length > 1) {
            let data: any = {classIds: []};
            for (let i = 0; i < this.exportClassId.length; i++) {
                data.classIds.push(this.exportClassId[i]);
            }

            let url = '/api/v1/user/export/school/student';
            fetch(url, {
                method: 'POST',
                headers: new Headers({
                    Authorization: this.uploadHeaders['Authorization'],
                    'Content-Type': 'application/json'
                }),
                body: JSON.stringify(data)
            })
                .then(res => res.blob())
                .then(data => {
                    const blobUrl = window.URL.createObjectURL(data);
                    const a = document.createElement('a');
                    a.download = this.orgName + '学生信息' + '.zip';
                    a.href = blobUrl;
                    a.click();
                });
        }
    }
    //操作区导出名单导出
    handleExport(_id: string, name: string) {
        let url = '/api/v1/user/export/class/student' + '?classId=' + _id;
        fetch(url, {
            method: 'GET',
            headers: new Headers({
                Authorization: this.uploadHeaders['Authorization']
            })
        })
            .then(res => res.blob())
            .then(data => {
                const blobUrl = window.URL.createObjectURL(data);
                const a = document.createElement('a');
                a.download = this.orgName + name + '学生信息' + '.xlsx';
                a.href = blobUrl;
                a.click();
            });
    }
    //导出所有学生名单
    exportAllStudent() {
        fetch('/api/v1/user/export/school/student', {
            method: 'GET',
            headers: new Headers({
                Authorization: this.uploadHeaders['Authorization']
            })
        })
            .then(res => res.blob())
            .then(data => {
                const blobUrl = window.URL.createObjectURL(data);
                const a = document.createElement('a');
                a.download = this.orgName + '学生信息' + '.xlsx';
                a.href = blobUrl;
                a.click();
            });
    }

    //获取学校信息
    initOrganization() {
        let me = this;
        classesApi.getSchoolById({
            context: me,
            urlParamObj: {
                id: me.schoolId
            },
            success(data: any, parameters: any) {
                let domain = data.data;
                me.orgName = domain.name;
            },
            error(error: any, message: string, parameters: any) {
                me.$message.error(message);
            }
        });
    }
    // 获取学校个年级班级数量
    getGradeCount() {
        let me = this;
        classesApi.getGradeCount({
            context: me,
            urlQueryParmas: {
                code: 'learning_section'
            },
            success(data: any, parameters: any) {
                let domain = data.data;
                domain.forEach((el: any) => {
                    me.allPhaseCount += el.gradeCount;
                    if (el.code == 'primary') {
                        me.primaryCount = el.gradeCount;
                    } else if (el.code == 'junior') {
                        me.juniorCount = el.gradeCount;
                    } else if (el.code == 'senior') {
                        me.seniorCount = el.gradeCount;
                    }
                });
            },
            error(error: any, message: string, parameters: any) {
                me.$message.error(message);
            }
        });
    }

    onSelectChange(selectedRowKeys: any, selectedRows: any) {
        this.exportClassId = selectedRowKeys;
        this.exportClassName = selectedRows;
    }
    //===================================methods区域end

    created() {
        let value = window.localStorage.getItem('aicp_school_materials_$state_aicp_school_materials');
        this.schoolId = JSON.parse(value as string).schoolId;
        this.initOrganization();
        let user = this.$app.getState();
        this.uploadHeaders['Authorization'] = 'Bearer ' + user.token;
        this.getList();
        this.getGradeCount();
    }

    beforeDestroy() {
        window.localStorage.removeItem('classId');
    }
}
